import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetTargetingCategory  {
    _originalTypeClassName = "zERP.BO.BudgetTargetingCategory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetTargetingCategory.translate = translateService;
}
this.BudgetItems = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.Description = null;
this.IsExpense = false;
this.BudgetItemsStr = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Description:any;
IsExpense:any;
BudgetItemsStr:any;
BudgetItems:any;
static setBudgetItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.BudgetItems == null) $this.BudgetItems = [];

                const copyItems = Common.cloneObject(items);

                while ($this.BudgetItems.length > 0) {
                    Domain.BudgetTargetingCategory.removeBudgetItems($this, $this.BudgetItems[0]);
                }

                Domain.BudgetTargetingCategory.addManyBudgetItems($this, copyItems);
            }
static addManyBudgetItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BudgetTargetingCategory.addBudgetItems($this, items[i]);
                }
            }
static addBudgetItems = ($this, item) => {
                if ($this.BudgetItems == null) $this.BudgetItems = [];
                if (item == null || $this.BudgetItems.indexOf(item) > -1) return;
                $this.BudgetItems.push(item);
}
static addRangeBudgetItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BudgetTargetingCategory.addBudgetItems($this, item));
            }
static removeBudgetItems = ($this, item) => {
                if ($this == null || $this.BudgetItems == null || $this.BudgetItems.indexOf(item) === -1) return;
                var _index = $this.BudgetItems.indexOf(item);
                $this.BudgetItems.splice(_index, 1);
}
static clearBudgetItems = ($this) => { $this.BudgetItems = null; }

static CreateDefault(): any{let budgetTargetingCategory = new Domain.BudgetTargetingCategory();
budgetTargetingCategory.IsExpense = true;
return budgetTargetingCategory;
}
static GetBudgetItemsStr($this: any): any{return CLMS.Framework.String.Join(", ", $this?.BudgetItems?.linq?.select((i) => i?.Code)?.toArray());
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}